import AxiosRequest from "./instance";

// 🔁 Product API нь features/products/api/productsApi.js-д нүүсэн (Фаз 5).
// Хуучин import ("api/axios/requests") хэвээр ажиллана.
export {
  fetchProducts,
  updateProduct,
  deleteProduct,
  createProduct,
  uploadProductImage,
  fetchImagelessProducts,
  removeDraftProduct,
  lookupDraftProduct,
  uploadDraftImage,
} from "features/products/api/productsApi";

export async function fetchCategories() {
  const result = await AxiosRequest({
    url: "/merchant/product/categories",
    method: "get",
  });
  return result;
}

// 🔁 Auth API (login, verifyPassword) нь features/auth/api/authApi.js-д нүүсэн (Фаз 8).
export { login, verifyPassword } from "features/auth/api/authApi";

// 🔁 openCloseAPI нь features/settings/api/settingsApi.js-д нүүсэн (Фаз 3).
export { openCloseAPI } from "features/settings/api/settingsApi";

export async function getMerchantMe() {
  const result = await AxiosRequest({
    url: "/merchant/getMerchantMe",
    method: "post",
  });
  return result;
}

// 🔁 fetchOrders нь features/history/api/historyApi.js-д нүүсэн (Фаз 4).
export { fetchOrders } from "features/history/api/historyApi";

export async function fetchNewOrders() {
  const result = await AxiosRequest({
    url: "/merchant/fetchNewOrders",
    method: "post",
  });
  return result;
}

export async function fetchOrderDetails({ orderId }) {
  const result = await AxiosRequest({
    url: "/merchant/fetchOrderDetails",
    method: "post",
    data: {
      orderId,
    },
  });
  return result;
}

export async function updateOrderStatus({ orderId, statusId, prepDuration }) {
  const result = await AxiosRequest({
    url: "/merchant/updateOrderStatus",
    method: "post",
    data: {
      orderId,
      statusId,
      prepDuration,
    },
  });
  return result;
}

/**
 * Бэлтгэх хугацааг сунгах — 10 эсвэл 20 минут, захиалга тутамд 1 удаа (2026-09-17).
 * Хэрэглэгч ба жолоочид «ресторан хугацаа сунгалаа» гэж харагдана.
 */
export async function extendPrepTime({ orderId, minutes }) {
  const result = await AxiosRequest({
    url: "/merchant/order/extend-prep",
    method: "post",
    data: { orderId, minutes },
  });
  return result;
}

/**
 * Захиалгын жолооч: ирж байна / ирсэн, байршил (зөвхөн энэ ресторан руу
 * явж байгаа эсвэл ирсэн үед), зай, ойролцоо хугацаа.
 */
export async function getOrderDriver(orderId) {
  const result = await AxiosRequest({
    url: `/merchant/orders/${Number(orderId)}/driver`,
    method: "get",
  });
  return result;
}

// 🔁 Delivery API нь features/delivery/api/deliveryApi.js-д нүүсэн (Фаз 7).
export {
  getMerchantAddress,
  getAllDistricts,
  getPackageSizes,
  getPackagePrices,
  createManualOrder,
  fetchManualOrders,
  createQpayInvoice,
  checkQpayPayment,
} from "features/delivery/api/deliveryApi";

// 🔁 Discount API нь features/discounts/api/discountsApi.js-д нүүсэн (Фаз 6).
export {
  getMerchantDiscounts,
  createProductDiscount,
  cancelProductDiscount,
  createBonusRule,
} from "features/discounts/api/discountsApi";

// 🔁 Category API нь features/categories/api/categoriesApi.js-д нүүсэн (Фаз 2).
// Хуучин import ("api/axios/requests") хэвээр ажиллана.
export {
  getMerchantCategories,
  createMerchantCategory,
  uploadCategoryImage,
  deleteCategory,
  updateCategory,
} from "features/categories/api/categoriesApi";

// E24-ээс мерчантад чиглэсэн мэдээллийн баннер (зөвхөн харах)
export async function getMerchantBanners() {
  const result = await AxiosRequest({
    url: "/merchant/banners",
    method: "get",
  });
  return result;
}

/* Хэрэглэгчийн үнэлгээний жагсаалт (2026-09-18) — сүүлийнх нь эхэндээ.
   `before` — өмнөх хуудас, `after` — шинээр ирсэн. */
export async function getRatingsFeed({ before, after } = {}) {
  const params = {};
  if (before != null) params.before = before;
  if (after != null) params.after = after;
  const result = await AxiosRequest({
    url: "/merchant/ratings/feed",
    method: "get",
    params,
  });
  return result;
}

// Гүйцэтгэлийн статистик — энэ 7 хоног + өнгөрсөн 7 хоног
export async function getMerchantPerformance() {
  const result = await AxiosRequest({
    url: "/merchant/performance",
    method: "get",
  });
  return result;
}

// 7 хоногийн шилдэгт сонгогдсон featured бараануудыг татна
export async function getWeeklyFeaturedProducts() {
  return await AxiosRequest({ url: "/merchant/weekly-products", method: "get" });
}

// 7 хоногийн шилдэгт гаргах бараануудыг хадгална (max 8)
export async function saveWeeklyFeaturedProducts(productIds) {
  return await AxiosRequest({
    url: "/merchant/weekly-products",
    method: "post",
    data: { productIds },
  });
}

